export default {
  title: "Accept Performed Work",
  content: "This cannot be undone!",
  input_label: "Accepting comment",
}
